import i18n from '@/i18n'

/**
 * 将 vue-i18n 的 locale 转为后端 get_translation_function 能识别的 Accept-Language。
 * 必须与 eSIM_API app/dependencies._normalize_language 行为一致（如 zh-CN → cn）。
 */
const LOCALE_TO_ACCEPT_LANGUAGE = {
  en: 'en',
  zh: 'zh-CN',
  'zh-HK': 'zh-HK',
  de: 'de',
  es: 'es',
  ja: 'ja',
  th: 'th',
  fr: 'fr',
  pt: 'pt',
  ru: 'ru',
  it: 'it',
  tr: 'tr',
  ko: 'ko'
}

export function getAcceptLanguageForApi () {
  const loc = i18n.global.locale.value
  if (LOCALE_TO_ACCEPT_LANGUAGE[loc]) {
    return LOCALE_TO_ACCEPT_LANGUAGE[loc]
  }
  if (typeof loc === 'string' && loc.length) {
    return loc
  }
  return 'en'
}
